export class SuppliersResources {
  public static suppliers = [
    {
      id: 1,
      resource: {
        user_id: "123456",
        name: "Trevino Marvel1",
      },
      supplier: {
        uuid: "345456",
        name: "Ketty Marvel",
      },
    },
    {
      id: 2,
      resource: {
        user_id: "123456",
        name: "Trevino Marvel2",
      },
      supplier: {
        uuid: "345456",
        name: "Ketty Marvel",
      },
    },
    {
      id: 3,
      resource: {
        user_id: "123456",
        name: "Trevino Marvel3",
      },
      supplier: {
        uuid: "345456",
        name: "Ketty Marvel",
      },
    },
    {
      id: 4,
      resource: {
        user_id: "123456",
        name: "Trevino Marvel4",
      },
      supplier: {
        uuid: "345456",
        name: "Ketty Marvel",
      },
    },
    {
      id: 5,
      resource: {
        user_id: "123456",
        name: "Trevino Marvel",
        status: 1
      },
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      }
    },
    {
      id: 6,
      resource: {
        user_id: "4321432143214321",
        name: "Trevino Marvel2",
        status: 2
      },
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      }
    },
    {
      id: 7,
      resource: {
        user_id: "new-resource-001",
        name: "John Security Guard",
        status: 1
      },
      supplier: {
        uuid: "789078",
        name: "Jack Allon"
      }
    },
    {
      id: 8,
      resource: {
        user_id: "new-resource-001",
        name: "John Security Guard",
        status: 1
      },
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      }
    },
    {
      id: 9,
      resource: {
        user_id: "new-resource-002",
        name: "John Security BodyGuard",
        status: 1
      },
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      }
    },
    {
      id: 10,
      resource: {
        user_id: "new-resource-002",
        name: "John Security BodyGuard",
        status: 1
      },
      supplier: {
        uuid: "90909088888",
        name: "Ketty Marvel"
      }
    },
    {
      id: 11,
      resource: {
        user_id: "res-sarah-001",
        name: "Sarah Johnson",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      id: 12,
      resource: {
        user_id: "res-mike-001",
        name: "Mike Chen",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      id: 13,
      resource: {
        user_id: "res-alex-001",
        name: "Alex Rivera",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      id: 14,
      resource: {
        user_id: "res-emma-001",
        name: "Emma Watson",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    // ── TEZY2-4185: Governance test resources ──
    {
      id: 15,
      resource: {
        user_id: "res-gov-cancel-001",
        name: "Cancelled Carl",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      id: 16,
      resource: {
        user_id: "res-gov-ranp-001",
        name: "RANP Rachel",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      id: 17,
      resource: {
        user_id: "res-gov-draft-001",
        name: "Draft Dave",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      id: 18,
      resource: {
        user_id: "res-gov-past-001",
        name: "Past Pete",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    },
    {
      // TEZY2-4473: row for the always-deletable draft shift (series-delete.cy.ts)
      id: 19,
      resource: {
        user_id: "res-series-delete-001",
        name: "Series Sam",
        status: 1
      },
      supplier: {
        uuid: "12341234134",
        name: "Jack Allon"
      }
    }
  ];
}
